// @ts-nocheck
import { Column } from 'react-table'
import { formatDateTime } from '../../../../../utils/dayJs/format'
import { CustomHeader } from './CustomHeader'
import { ContractTerm } from '../../../core/_models'

const ContractTermColumns: ReadonlyArray<Column<ContractTerm>> = [
  {
    Header: (props) => <CustomHeader tableProps={props} title='ID' className='min-w-50px' />,
    accessor: 'id',
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Nome' className='min-w-150px' />,
    accessor: 'name',
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Descrição' className='min-w-250px' />,
    accessor: 'description',
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Criado em' className='min-w-125px' />
    ),
    id: 'data',
    Cell: ({ ...props }) => {
      const createdAt = props.data[props.row.index].createdAt
      return createdAt ? formatDateTime(createdAt) : 'N/A'
    },
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Atualizado em' className='min-w-125px' />
    ),
    id: 'two_steps',
    Cell: ({ ...props }) => {
      const updatedAt = props.data[props.row.index].updatedAt
      return updatedAt ? formatDateTime(updatedAt) : 'N/A'
    },
  },
]

export { ContractTermColumns }
